import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import type { RedeemItemProps } from '../../../../contexts/redeem-offers';
import { useRedeemOfferItem } from '../../../../hooks/redeem-offer-item';
import { LoadingRow } from '../Loading';

import { Desktop } from './desktop';
import { Mobile } from './mobile';
import { Tablet } from './tablet';

type ItemProps = {
  data: RedeemItemProps;
};

export interface LayoutItemProps {
  data: RedeemItemProps;
  isDisabledButton: boolean;
  onRemove: (fileRowId: string, basketCustomerOfferId: string) => void;
  isLoading?: boolean;
}

export const Item: React.FC<ItemProps> = (props) => {
  const { onRemoveRedeemItem, isDisabledRemoveRedeemButton, isRemovingRedeemItem } =
    useRedeemOfferItem({ statusId: 0 });
  // useRedeemOfferItem({ statusId: props.data.status?.statusId });

  const params = {
    ...props,
    onRemove: onRemoveRedeemItem,
    isDisabledButton: isDisabledRemoveRedeemButton,
  };

  const layout = useBreakpointValue({
    base: <Mobile {...params} />,
    sm: <Tablet {...params} />,
    lg: <Desktop {...params} />,
  });

  if (isRemovingRedeemItem) {
    return <LoadingRow />;
  }

  return layout;
};
